import { useEffect } from 'react'

import { useEventTracking } from './logging/tracking'
import config from '../env'

type IntercomSettings = NonNullable<typeof window.intercomSettings>

export const initIntercom = () => {
  window.Intercom('boot', {
    app_id: config.intercomKey,
    hide_default_launcher: true,
  })
}

type IntercomParams = {
  showLauncher?: boolean
}

export const useIntercom = ({ showLauncher }: IntercomParams = {}) => {
  const track = useEventTracking()

  initIntercom()

  const update = (settings?: IntercomSettings) => {
    window.Intercom('update', {
      ...settings,
    })
  }

  const show = () => {
    window.Intercom('show')
  }

  const showDefaultLauncher = () => {
    window.Intercom('update', { hide_default_launcher: false })
  }

  useEffect(() => {
    window.Intercom('onShow', () => track('clickOpenIntercom'))

    if (!showLauncher) {
      return
    }

    update({ hide_default_launcher: false })
    return () => window.Intercom('shutdown')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    update,
    show,
    showDefaultLauncher,
  }
}
